import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api_call from "../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { API } from "../../globals/constants";

const initialState = {
  loading: false,
  StudioResponse: [],
  error: "",
  regionData: [],
};

export const StudioList = createAsyncThunk(
  "trainingcenterlist/ReduxTrainingCenterList",
  ({ token }) => {
    return axios
      .get(
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
          API.END_POINTS.STUDIO_LIST,
        {
          headers: {
            Authorization: token,
          },
        }
      )
      .then((response) => response.data);
  }
);
const trainingcenterlistSlice = createSlice({
  name: "trainingcenterlist",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(StudioList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(StudioList.fulfilled, (state, action) => {
      state.loading = false;
      state.StudioResponse = action.payload;
      state.error = "";
    });
    builder.addCase(StudioList.rejected, (state, action) => {
      state.loading = false;
      state.StudioResponse = [];
      state.error = action.error.message;
    });
  },
});
export const RegionList = createAsyncThunk(
  "regionList/api",
  ({ token, params }) => {
    return api_call(
      "get",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.GET_AWS_REGION
      }`,
      params,
      {},
      {}
    );
  }
);
const regionListSlice = createSlice({
  name: "regionList",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(RegionList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(RegionList.fulfilled, (state, action) => {
      state.loading = false;
      state.regionData = action.payload;
      state.error = "";
    });
    builder.addCase(RegionList.rejected, (state, action) => {
      state.loading = false;
      state.regionData = [];
      state.error = action.error.message;
    });
  },
});
export const TrainingCenter = {
  training_center_list: trainingcenterlistSlice.reducer,
  region_list: regionListSlice.reducer,
};
